import Cookies from 'js-cookie';
import localize from './localize';

document.querySelectorAll('.js-privacy-panel').forEach((element) => {
  element.classList.add('o-wrapper');

  ['bite', 'instagram', 'podcaster', 'vimeo', 'youtube'].forEach(
    (platform) => {
      element.insertAdjacentHTML(
        'beforeend',
        `
          <div class="o-column-container--2-columns-default c-privacy-panel__inner">
            <div class="c-privacy-panel__message-and-policy-link o-column-container__column o-column-container__column--leading c-privacy-panel__status-container">
              <h3 class="c-privacy-panel__headline u-headline u-headline-small c-privacy-panel__status-headline"></h3>
              <p class="c-paragraph c-privacy-panel__status"></p>
            </div>
            <div class="c-privacy-panel__status-and-button o-column-container__column o-column-container__column--following c-privacy-panel__button-container">
            </div>
          </div>
        `
      );

      let panelForPlatform = element.lastElementChild;
      let statusText = panelForPlatform.querySelector('.c-privacy-panel__status');
      let statusHeadline = panelForPlatform.querySelector('.c-privacy-panel__status-headline');
      statusHeadline.textContent = localize('privacy.name.' + platform);

      if (Cookies.get('terms-accepted-' + platform) === '1') {
        statusText.textContent = localize('privacy.implications_text.active').replace(
          '%s',
          localize('privacy.name.' + platform)
        );
        statusText.insertAdjacentHTML(
          'afterend',
          '<p class="c-paragraph"><a class="c-privacy-panel__policy-link"></a></p>'
        );

        let policyLink = statusText.nextElementSibling.firstElementChild;
        policyLink.href = localize('privacy.terms_link.' + platform);
        policyLink.textContent = localize('privacy.terms_link_text.' + platform);

        let buttonContainer = panelForPlatform.querySelector('.c-privacy-panel__button-container');
        buttonContainer.innerHTML = `<button class="c-button c-button--style-default"><span class="c-button__label"></span></button>`;

        let button = buttonContainer.firstElementChild;
        let buttonLabel = button.firstElementChild;

        buttonLabel.textContent = localize('privacy.revoke_button');
        buttonLabel.insertAdjacentHTML(
          'beforeend',
          ' <span class="u-hidden-visually"></span>'
        );
        buttonLabel.lastElementChild.textContent = localize('privacy.panel_button.screen_reader_text').replace(
          '%s',
          localize('privacy.name.' + platform)
        );

        button.addEventListener(
          'click',
          () => {
            Cookies.remove(
              'terms-accepted-' + platform,
              { secure: true }
            );

            statusText.textContent = localize('privacy.implications_text.revoked').replace(
              '%s',
              localize('privacy.name.' + platform)
            );
            statusText.nextElementSibling.remove();
            button.remove();
          }
        );
      } else {
        statusText.textContent = localize('privacy.implications_text.inactive').replace(
          '%s',
          localize('privacy.name.' + platform)
        );
      }
    }
  );
});
